import React from "react";
import "../../../css/Praplanning/ParaplanningFields.css";

const ParaplanningTextareaField = ({
  label,
  required = false,
  value = "",
  onChange,
  placeholder = "",
  name,
  disabled = false,
  error = "",
  className = "",
  rows = 4,
}) => {
  return (
    <label className="ParaplanningField">
      {label && (
        <span className="ParaplanningField__Label FP_Body">
          {label}
          {required && <span className="ParaplanningField__Required">*</span>}
        </span>
      )}

      <textarea
        className={`ParaplanningField__Input ParaplanningField__Textarea FP_Content black ${className} ${
          error ? "ParaplanningField__Input--Error" : ""
        }`}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        onChange={(event) => onChange(event.target.value)}
        required={required}
      />

      {error && <span className="ParaplanningField__Error">{error}</span>}
    </label>
  );
};

export default ParaplanningTextareaField;
